import { AddCandidatesPageComponent } from "./add-candidates-page.component";
import { AddCandidatesModule } from "./addCandidates/add-candidates.module";
export var AddCandidatesPageModule = angular
    .module('addCandidatesPage', [AddCandidatesModule])
    .config(['$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('missioncontrol.addCandidates', {
            url: '/addCandidates',
            component: AddCandidatesPageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                jobId: null
            }
        });
    }
])
    .component(AddCandidatesPageComponent.selector, AddCandidatesPageComponent.component)
    .name;
//# sourceMappingURL=add-candidates-page.module.js.map